// extracted by mini-css-extract-plugin
module.exports = {"root":"service-infos-module--root--2ksDk","card":"service-infos-module--card--2pVHJ"};